import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from '@mui/material/IconButton';
import FilterListIcon from '@mui/icons-material/FilterList';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import Chip from '@mui/material/Chip';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {ReactComponent as Search} from '../Layer_images/Settings_images/search.svg';
import {ReactComponent as Filter} from '../Layer_images/Settings_images/filter.svg';
// import {ReactComponent as Marker} from '../Layer_images/Settings_images/Marker.svg';
import { ExportButton } from './ExportButton';
import axios from 'axios';

export const SidebarMainLocations = ({mapLocationClicked, exportInProgress, exportData, addOpacityToColor, checkStatusExpanded, filterMapLocationsFunc, filterMapLocations, passesAllFilters, status, brand, handleRemoveFilter, handleAddFilter, locationFilters, getlocations, getprospectsidebar, showManagementMapping }) => {
    // console.log('checkStatusExpanded: ', checkStatusExpanded)
    const [locationFiltersLocal, setLocationFiltersLocal] = useState(locationFilters);

    const [searchTerm, setSearchTerm] = useState('');
    const [selectedOperation, setSelectedOperation] = useState(null);
    const [filterOperationTypes, setFilterOperationTypes] = useState(['=', '!=']);
    const [filterValuesOptions, setFilterValuesOptions] = useState([]);
    const [filterError, setFilterError] = useState();
    const [selectedField, setSelectedField] = useState(null);
    const [filterValue, setFilterValue] = useState('');
    const [filterAnchorEl, setFilterAnchorEl] = useState(null);
    const [filteredLocationsByStatus, setFilteredLocationsByStatus] = useState({});
    const [checkStatusExpandedLocal, setCheckStatusExpandedLocal] = useState(checkStatusExpanded);

    const filterOptions = ['Brand', 'Status']

    const showManagementClicked = (e) => {
        getprospectsidebar(e.coordinates);
        showManagementMapping(e);
    };

    useEffect(() => {
        setCheckStatusExpandedLocal(checkStatusExpanded)
    }, [checkStatusExpanded])

    const handleLocalChange = (locationFilters, searchTerm) => {
        const filteredLocations = getlocations.business_data?.filter((location) =>{
            if(locationFilters.length === 0 && searchTerm === '') return true;
            return passesAllFilters(location, locationFilters) && location.name.toLowerCase().includes(searchTerm.toLowerCase())
        });

        const groupedLocations = filteredLocations?.reduce((acc, location) => {
            if (acc[location.status]) {
                acc[location.status].push(location);
            } else {
                acc[location.status] = [location];
            }
            return acc;
        }, {});
        setFilteredLocationsByStatus(groupedLocations || {});
    }

    useEffect(() => {
        handleLocalChange(locationFilters, searchTerm);
    }, [locationFilters]);

    const handleFilterIconClick = (event) => {
        setFilterAnchorEl(event.currentTarget);
    };


    const handleFilterClose = () => {
        setFilterAnchorEl(null);
    };

    const handleAddValue = () => {
        if(!selectedField) return setFilterError('Select Filter')
        if(!filterValue) return setFilterError('Select Filter Value')
        if(!selectedOperation) return setFilterError('Select Filter Operator')
        setFilterError(null)
        handleAddFilter(selectedField, filterValue, selectedOperation);
        setSelectedField(null)
        setFilterValue(null)
        setSelectedOperation(null)
        handleFilterClose()
    }

    const handleRemoveLocation = (index) => handleRemoveFilter(index)


    const set_filterOptions = (event, newValue) => {
        setSelectedField(newValue);
        const value = newValue === 'Brand' ? brand: status;
        setFilterValuesOptions(value);
    }

    const changeStatusExpand = async (status, isExpanded) => {
        const token = localStorage.getItem("auth-token");
        setCheckStatusExpandedLocal(prevStatus => {
            const updatedStatus = { ...prevStatus, [status]: isExpanded };
            // Optionally, you might want to move the API call here to ensure it uses the latest state
            axios.post('/gettheurl/change-status', {checkStatusExpanded: updatedStatus}, {headers:{ "auth-token": token}})
                 .then(response => {
                     console.log("Status update response:", response.data);
                 })
                 .catch(error => {
                     console.error("Error updating status:", error);
                 });
            return updatedStatus;
        });
    }


    const open = Boolean(filterAnchorEl);
    const id = open ? 'filter-popover' : undefined;

    return (
        Object.keys(getlocations).length !== 0 &&
            <div className="sidebar-realestate-total">

            <div className=" mb-20 h-100 pb-10">
                <div className='display-flex'>
                <div className='mr-10'><Search className='main-filter-image' />
                <input className="prospect-searchbar w-368" placeholder="Search Locations" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}></input>
                </div>
                <button className='main-filter-search' onClick={handleFilterIconClick}> 
                    Filter <Filter/>    
                </button>
                </div>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={filterAnchorEl}
                    onClose={handleFilterClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <div style={{ padding: '10px', backgroundColor: 'white', width: '380px' }}>
                        <div style={{ display: 'flex', marginBottom: '10px' }}>
                            <Autocomplete
                                options={filterOptions}
                                getOptionLabel={(option) => option}
                                value={selectedField}
                                style={{  width: '50%'  }}
                                onChange={set_filterOptions}
                                renderInput={(params) => <TextField {...params} label="Select Field"                   variant="standard"
                                sx={{
                                    "& .MuiInputBase-input": { fontSize: '12px' }, // Sets font size of the input text
                            "& .MuiInputLabel-root": { fontSize: '12px' },
                                    "& input": { fontSize: '12px' }, // Adjust color as needed
                                    mb: 0.625
                                }}    
                                />}
                            />
                            <Autocomplete
                                options={filterOperationTypes}
                                getOptionLabel={(option) => option}
                                value={selectedOperation}
                                style={{  width: '30%' , marginLeft:'15px' }}
                                onChange={(event, newValue) => setSelectedOperation(newValue)}
                                renderInput={(params) => <TextField {...params} label="Condition"                   variant="standard"
                                sx={{
                                    "& .MuiInputBase-input": { fontSize: '12px' }, // Sets font size of the input text
                            "& .MuiInputLabel-root": { fontSize: '12px' },
                                    "& input": { fontSize: '12px' }, // Adjust color as needed
                                    mb: 0.625
                                }}    
                                />}
                            />
                            <Autocomplete
                                options={filterValuesOptions}
                                getOptionLabel={(option) => option}
                                value={filterValue}
                                style={{ marginLeft: '15px', width: '70%'  }}
                                onChange={(event, newValue) => setFilterValue(newValue)}
                                renderInput={(params) => <TextField {...params} label="Filter Value"                   variant="standard"
                                sx={{
                                    "& .MuiInputBase-input": { fontSize: '12px' }, // Sets font size of the input text
                            "& .MuiInputLabel-root": { fontSize: '12px' },
                                    "& input": { fontSize: '12px' }, // Adjust color as needed
                                    mb: 0.625
                                }}    
                                />}
                            />

                        </div>
                        <div>{filterError}</div>
                        {/* <Button variant="contained" color="primary" onClick={handleAddFilter}>Add Filter</Button> */}
                        <div className="main-mapping-save mb-20 mt-20" >
                            <div id="box-goback" className={`cursor-pointer color-purple`} onClick={handleAddValue}>Add Filter</div>
                        </div>
                    </div>
                </Popover>
                {locationFilters?.length > 0 && <div className='box-container' style={{    padding: 20, textAlign: 'start', margin: '20px 0'}}>
                <div className='display-inline-block mb-10 '>
                    Location Filters
                </div>
                <div style={{ marginBottom: 10}}>
                {locationFilters?.map((filter, index) => (
                    <Chip
                        key={index}
                        label={`${filter.field} ${filter.operator} ${filter.value}`}
                        onDelete={() => handleRemoveLocation(index)}
                        style={{ marginRight: 8, marginBottom: 8 , padding: 5,    background: 'none', border: '1px solid #E9EAEB', borderRadius: 8}}
                    />
                ))}
                </div>
                <div >
                    <div className='display-inline-block font-size-14'>
                    Hide markers
                    </div>
                    <label className="layer-toggle-switch-filter">
                        <input type="checkbox" checked={filterMapLocations} onChange={() => filterMapLocationsFunc()} />
                        <span className="layer-toggle-slider layer-toggle-round"></span>
                    </label>
                </div>
                </div>}
            </div>
            {mapLocationClicked?.custom && <ExportButton exportData={exportData} exportInProgress={exportInProgress}/>}

            {Object.keys(filteredLocationsByStatus).map((status) => {
                const filteredLocations = filteredLocationsByStatus[status].filter(location =>
                    location.name.toLowerCase().includes(searchTerm.toLowerCase())
                );

                // Only render the status section if there are filtered locations
                if (filteredLocations.length === 0) {
                    return null;
                }

                return (
                        <Accordion 
                            key={status} 
                            expanded={checkStatusExpandedLocal[status] || searchTerm.length > 0} 
                            onChange={(e, isExpanded) => changeStatusExpand(status, isExpanded)}
                            sx={{ 
                                marginTop:'20px',
                                boxShadow: 'none',
                                border: 'none',
                                '&.MuiPaper-root': {
                                  boxShadow: 'none',
                                  border: 'none'
                                },
                                '&::before': {
                                  display: 'none',
                                  backgroundColor: 'transparent'
                                },
                                '& .MuiAccordion-root': {
                                  boxShadow: 'none',
                                  border: 'none'
                                },
                                '& .MuiAccordionSummary-root': {
                                  padding: 0,
                                  minHeight: 'auto'
                                },
                                '& .MuiAccordionDetails-root': {
                                  padding: 0
                                }
                            }}
                            >
                            <AccordionSummary 
                                expandIcon={<ExpandMoreIcon />} 
                                aria-controls="panel1a-content" 
                                id="panel1a-header"
                                sx={{
                                flexDirection: 'row',
                                '& .MuiAccordionSummary-content': {
                                    margin: 0
                                }
                                }}
                            >
                                <div className="" style={{ 
                                fontWeight: 'bold', 
                                paddingTop: 0, 
                                color: getlocations.status_colors[status],
                                display: 'flex',
                                alignItems: 'center' 
                                }}>
                                {status}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                {filteredLocations.map((location) => (
                                    <div key={location.name} onClick={() => showManagementClicked(location, true)} className="total-locations-sidebar hover-color-grey-click" style={{backgroundColor: addOpacityToColor(getlocations.status_colors[status])}}>
                                        <div>
                                        <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M17.6201 7.45C16.5701 2.83 12.5401 0.75 9.0001 0.75C9.0001 0.75 9.0001 0.75 8.9901 0.75C5.4601 0.75 1.4201 2.82 0.370095 7.44C-0.799905 12.6 2.3601 16.97 5.2201 19.72C6.2801 20.74 7.6401 21.25 9.0001 21.25C10.3601 21.25 11.7201 20.74 12.7701 19.72C15.6301 16.97 18.7901 12.61 17.6201 7.45ZM9.0001 12.46C7.2601 12.46 5.8501 11.05 5.8501 9.31C5.8501 7.57 7.2601 6.16 9.0001 6.16C10.7401 6.16 12.1501 7.57 12.1501 9.31C12.1501 11.05 10.7401 12.46 9.0001 12.46Z"
                                                fill={getlocations.status_colors[status]}
                                            />
                                        </svg>
                                        </div>
                                        <div>
                                        <div className="name-locations-sidebar" style={{  color: getlocations.status_colors[status] }}>{location.name}</div>
                                        <div className="address-locations-sidebar">{location.address}</div>
                                        </div>
                                    </div>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                );
            })}
            {getlocations.business_data.length === 0 &&
                <div className="total-locations-sidebar">
                    <div className="name-locations-sidebar add-location-warning">
                        Add Locations either by dropping a Pin or searching
                    </div>
                </div>
            }
        </div>
    );
};
